<!-- =========================================================================================
  File Name: DeviceSidebar.vue
  Description: Dashcam detail - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{$t('UPDATE_DEVICE')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("DEVICE_UUID")}}</small>
          <p class="font-semibold text-lg text-right">{{ device.deviceUUID }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("USER_ID")}}</small>
          <p class="font-semibold text-lg text-right">{{ setUser(user) }}</p>
        </div>
        <div class="mt-5">
          <label class="vs-select--label">{{$t('DEVICE_STATUS')}}</label>
          <v-select :options="deviceStatus" label="text" name="deviceStatus" :get-option-label="getLabel" v-model="device.deviceStatus" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false" >
              <template v-slot:option="option">
                {{ $t(option.text) }}
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('deviceStatus')">{{ errors.first('deviceStatus') }}</span>
        </div>
        <!--<span class="text-danger text-sm" v-show="errors.has('deviceStatus')">{{ errors.first('deviceStatus') }}</span>-->
        <vs-divider />
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("SERVICE_STATUS")}}</small>
          <p class="font-semibold text-lg text-right">{{ $t(setServiceStatusName(device.serviceStatus)) }}</p>
        </div>
        <div class="mt-5">
          <label class="vs-select--label">{{$t('USED_SUBSCRIBE_STATUS')}}</label>
          <v-select :options="usedSubscribe" label="text" name="usedSubscribe"  :get-option-label="getLabel" v-model="device.usedSubscribe" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false" >
              <template v-slot:option="option">
                {{ $t(option.text) }}
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('usedSubscribe')">{{ errors.first('usedSubscribe') }}</span>
        </div>
         <vs-divider />
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("LAST_CONNECTED_TIME")}}</small>
          <p class="font-semibold text-lg text-right">{{ setLocalTime(device.lastConnectedTime) }}</p>
        </div>
         <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("PROMOTION_START_DATETIME")}}</small>
           <DatePicker lang="en" type="datetime" v-model="parsePromotionStartDateTime" width="200" :popupStyle="{'z-index': 53002}" class="mt-5 w-full"></DatePicker>
        </div>
      
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-5"  @click="openConfirm" :disabled="!isFormValid">{{$t('SUBMIT')}}</vs-button>
      <vs-button class="mr-5" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    DatePicker
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if(!val) return
      let { user, device } = JSON.parse(JSON.stringify(this.data))
      this.user = user
      this.device = device
      this.$validator.reset()
    },
    
  },
  data() {
    return {

      editPopup: false,
      confirmPopup: false,

      user:{
        userId: "",
      },
      device:{
        deviceUUID: "",
        userUUID:"",
        deviceStatus:"",
        serviceStatus:"",
        usedSubscribe:"",
        lastConnectedTime:"",
        promotionStartDateTime:""
      },

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any()
    },
    deviceStatus(){
      return this.$store.state.dataDevice.deviceStatus
    },
    usedSubscribe(){
      return this.$store.state.dataDevice.usedSubscribe
    },
    parsePromotionStartDateTime: {
      get(){
        let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let dateTime = this.$moment(this.device.promotionStartDateTime,'YYYYMMDDHHmmss').format()
        let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')

        return new Date(dateTimeToLocal)
      },
      set(val){
        this.device.promotionStartDateTime = this.$moment(val).format('YYYYMMDDHHmmss')
      }

    }
  },
  methods: {
    setDeviceStatusName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.deviceStatus.properties[status].name
    },
    setServiceStatusName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.serviceStatus.properties[status].name
    },
    setUsedSubscribeName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.usedSubscriptionStatus.properties[status].name
    },
    setLocalTime(time){
      if(!time){
        return '-'
      }else {
        let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let dateTime = this.$moment(time,'YYYYMMDDHHmmss').format()
        let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
          
        return dateTimeToLocal
      }
    },
    setUser(user){
      if(!user) return "-"
      return user.userId
    },
    editData(option, data){
      this.changeOption = option
      this.changeData = data
      this.editPopup = true
    },
    openConfirm() {
      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('CONFIRM'),
          text: this.$t('SUBMIT_CONFIRM_MESSAGE'),
          accept:  this.acceptEdit,
          acceptText: this.$t('CONFIRM'),
          cancelText: this.$t('CANCEL')
      })
    },
    acceptEdit(){
      this.$vs.loading()

      const obj = {
          userUUID: this.device.userUUID,
          deviceUUID: this.device.deviceUUID,
          deviceStatus : this.device.deviceStatus,
          usedSubscribe : this.device.usedSubscribe,
          promotionStartDateTime : this.device.promotionStartDateTime
      }
    
      this.$store.dispatch("dataDevice/updateDeviceStatus", obj)
      .then(() => {
        this.close()
        this.successAlert(this.$t("SUCCESS"),this.$t("UPDATE_DEVICE_STATUS_SUCCESS"))
        this.$parent.$refs.deviceTable.getData()
      })
      .catch(error => {
        this.close()
        this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    close(){
      this.confirmPopup = false
      this.editPopup = false
      this.$vs.loading.close()
      this.$emit('closeSidebar')
    },
    getLabel(option) {
      return this.$t([option.text])
    },
  },

}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.detail-list{
  border-bottom:1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 0;
}


.edit-icon svg{
  padding-top: 3px !important;
}

</style>
